import reducer from 'store/v2/index';

import { assignedActionType, unassignedActionType } from './constants'

// We have to have two reducers because we are dealing with different data entirely
export const userFacilities = reducer(assignedActionType);
export const userFacilitiesUnassigned = reducer(unassignedActionType);
